import { createApi } from '@reduxjs/toolkit/query/react';

import { DeleteStatusDto, DiscardScheduleSubmissionDto, StatusDto } from '../common/dto/common.dto';
import { FormDataCreateDto, FormDataUpdateDto, FormDataViewDto } from '../common/dto/formdata.dto';
import customFetchBase from './base.service';

export interface ReportDeleteParamsDto {
  confirmDelete?: boolean;
  selectedIds: string[];
}

const API_URI = import.meta.env.VITE_DATA_COLLECTION_SERVICE;
const TAG_TYPE = 'Report';
export const reportUpdateApi = createApi({
  reducerPath: 'reportUpdateApi',
  baseQuery: customFetchBase(`${API_URI}/api/form-data`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    updateFormData: builder.mutation<FormDataViewDto, Partial<FormDataUpdateDto>>({
      query(data) {
        return {
          url: ``,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    addFormData: builder.mutation<FormDataViewDto, Partial<FormDataCreateDto>>({
      query(body) {
        return {
          url: ``,
          method: 'POST',
          body,
        };
      },
    }),
    deleteFormData: builder.mutation<DeleteStatusDto, Partial<ReportDeleteParamsDto>>({
      query(params: ReportDeleteParamsDto) {
        return {
          url: ``,
          method: 'DELETE',
          body: params,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    discardScheduleInstance: builder.mutation<StatusDto, DiscardScheduleSubmissionDto>({
      query(body: DiscardScheduleSubmissionDto) {
        return {
          url: `discard-schedule-instance`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useAddFormDataMutation, useUpdateFormDataMutation, useDeleteFormDataMutation, useDiscardScheduleInstanceMutation } = reportUpdateApi;
